export const GLOBAL_NAVIGATION_ID = 'global';

export function getContextualRank(rankings, navigationId = GLOBAL_NAVIGATION_ID) {
    const ranking = (rankings ?? []).find((item) =>
        (item.navigationId === GLOBAL_NAVIGATION_ID && navigationId === GLOBAL_NAVIGATION_ID)
        || item.navigationId.split('_')[1] === navigationId
    );

    return ranking?.rank ? ranking.rank : null;
}
